import styled from "styled-components";
import { Row } from "../../../components/flex/styled";

export const PlansAndPricingWrapper = styled("div")(({ isMenuOpen }) => ({
  position: "relative",
  top: isMenuOpen ? "var(--mobileNavLinks)" : "0",
  padding: "calc(var(--pagePadding)/ 2) var(--pagePadding)",
  margin: "calc(var(--sectionMargin) * 2) auto",
  maxWidth: "1400px",
  width: "80%",
  "& .introduction": {
    textAlign: "center",
    marginBottom: "var(--flexGap)",
    "& h2": {
      marginBlockEnd: 0,
      color: "var(--color-text)",
    },
    "& p": {
      marginBlockStart: "0.5rem",
      marginBlockEnd: 0,
      color: "var(--color-text-light)",
    },
  },
  "@media screen and (min-width: 1024px)": {
    margin: "calc(var(--sectionMargin) * 3) auto",
  },
  "@media screen and (max-width: 1024px)": {
    margin: "calc(var(--sectionMargin) * 3) auto",
    width: "45%",
  },
  "@media screen and (max-width: 768px)": {
    width: "70%",
  },
}));

export const PlansAndPricingRow = styled(Row)(() => {
  return {
    gap: "var(--flexGap)",
    justifyContent: "center",
    alignItems: "stretch",
    "@media screen and (max-width: 1024px)": {
      flexDirection: "column",
    },
  };
});

export const MostPopularBadge = styled("div")(() => {
  return {
    position: "absolute",
    top: "-12px",
    left: "50%",
    transform: "translateX(-50%)",
    backgroundColor: "var(--color-primary)",
    color: "#FFFFFF",
    padding: ".45rem 1rem",
    borderRadius: "1.25rem",
    fontSize: "0.7rem",
    fontWeight: "700",
    letterSpacing: "1.5px",
    textTransform: "uppercase",
  };
});

export const PriceDisplay = styled("div")(() => {
  return {
    display: "flex",
    alignItems: "baseline",
    gap: "0.5rem",
    "& .amount": {
      fontSize: "2rem",
      fontWeight: "700",
      color: "var(--color-text)",
    },
    "& .period": {
      fontSize: "1rem",
      color: "var(--color-text-light)",
    },
  };
});

export const PricingCard = styled("div")(({ isHighlighted }) => {
  return {
    flex: 1,
    borderRadius: "12px",
    padding: "2rem",
    paddingTop: isHighlighted ? "3rem" : "2rem",
    display: "flex",
    flexDirection: "column",
    gap: "1.5rem",
    position: "relative",
    backgroundColor: "#FFFFFF",
    border: isHighlighted
      ? "2px solid var(--color-primary)"
      : "2px solid #E8E8E8",
    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.06)",
    transition: "all 0.3s ease",
    "&:hover": {
      boxShadow: "0 8px 16px rgba(0, 0, 0, 0.12)",
      transform: "translateY(-4px)",
    },
    "& h3": {
      marginBlock: 0,
      color: "var(--color-text)",
      fontSize: "2rem",
      fontWeight: "700",
    },
    "& p": {
      marginBlock: 0,
      color: "var(--color-text-light)",
      fontSize: "0.9rem",
    },
    "& button": {
      marginTop: "auto",
      transition: "all 0.3s ease",
    },
    "& button:hover": {
      backgroundColor: isHighlighted ? "#173b18" : "var(--color-primary)",
      color: "#FFFFFF",
    },
    "@media screen and (max-width: 1024px)": {
      minHeight: "auto",
    },
  };
});

export const CardFeatures = styled("ul")(() => {
  return {
    margin: 0,
    padding: "0 0 0 1.5rem",
    listStyle: "disc",
    display: "flex",
    flexDirection: "column",
    gap: "0.75rem",
    "& li": {
      color: "var(--color-text-light)",
      fontSize: "0.95rem",
      lineHeight: "1.5",
    },
  };
});
